/**
 * Adds animation to the circle overlays for the Circle Transition CTA paragraph.
 *
 * As the page scrolls with the cirlces in view, they scale from large to small and
 * also transition from having a border to being filled.
 *
 * @author Brian McGill <github.com/bmcgill>
 */

(function ($) {
  'use strict';

  Drupal.behaviors.initializeCircleTransitionCTA = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    const $circles = $('.circle-transition-cta .circle');
    if (!$circles.length) return false;

    const $bannerHeight = $('header').height();

    $circles.each(function () {
      const $cir = $(this);
      let $position = { top: 0, left: 0 },
        $offset = { top: 0, bottom: 0 },
        $scrollHeight,
        $startPos;

      // Wait for Scrolling Image Fader to complete loading.
      // It changes the document height, which needs to stop before we calculate positioning.
      let $scrollingImageFader = $('.scrolling-image-fader');
      if ($scrollingImageFader && !$scrollingImageFader.hasClass('loaded')) {
        setInterval(function () {
          if ($scrollingImageFader.hasClass('loaded')) {
            setupCircle();
          }
        }, 200);
      } else {
        setupCircle();
      }

      $(window).on('resize', function () {
        setupCircle();
      });

      $(window).on('resize scroll', function () {
        if ($cir.isInViewport()) {
          resizeCircle(
            $cir,
            $startPos,
            $position['top'],
            $position['left'],
            $scrollHeight
          );
        }
      });

      /**
       * Setup Circle.
       * Element position changes based on screen size.
       */
      function setupCircle() {
        // Adjust start option depending on the device.
        let isMobile = window.matchMedia(
          'only screen and (max-width: 767px)'
        ).matches;

        // Position: centerpoint of circle on the image. Based on the desktop size (220x169).
        // Offset: pixels from top and bottom of the screen. Limits when animation starts and ends.
        if ($cir.parent().parent().parent().hasClass('left')) {
          // Left Circle
          $position = { top: 112, left: 120 };
          $offset = { top: 350, bottom: 50 };
        } else {
          // Right Circle
          $position = { top: 45, left: 185 };
          $offset = { top: 50, bottom: 350 };
        }

        if (isMobile) {
          // Same behavior for both circles since they are stacked.
          // Calculate position as a percentage and apply to mobile/tablet image size.
          $position['top'] = Math.round(
            ($position['top'] / 169) * $cir.parent().height()
          );
          $position['left'] = Math.round(
            ($position['left'] / 220) * $cir.parent().width()
          );
          $offset = { top: 50, bottom: 50 };
        }

        // Position from bottom of screen to start animation.
        $startPos = Math.round(
          $cir.parent().parent().offset().top -
            $(window).height() +
            $offset['bottom'] +
            $position['top']
        );

        // Distance from animation start to end.
        if (isMobile) {
          $scrollHeight =
            $cir.parent().parent().siblings('a.button').offset().top -
            $(window).height() -
            $startPos +
            $cir.parent().parent().siblings('a.button').height();
        } else {
          $scrollHeight =
            $(window).height() -
            $offset['top'] -
            $offset['bottom'] -
            $bannerHeight;
        }

        resizeCircle(
          $cir,
          $startPos,
          $position['top'],
          $position['left'],
          $scrollHeight
        );
      }
    });
  }

  /**
   * Resize Circle.
   * Calculate size, position, and opacity.
   */
  function resizeCircle($el, $start, $top, $left, $height) {
    // Calculate the percentage that the circle's range/height has been scrolled.
    let $distanceScrolled = window.scrollY - $start;
    let $percentageScrolled =
      100 - Math.round($distanceScrolled / ($height / 100));

    // Limit percent from 0-100.
    if ($percentageScrolled > 100) {
      $percentageScrolled = 100;
    } else if ($percentageScrolled < 0) {
      $percentageScrolled = 0;
    }

    let $size = Math.round($percentageScrolled * 2.2 + 60); // Min 60px. Max 280px. 100*2.2+60=280.

    // Update circle attributes.
    $el.find('.border').css('opacity', $percentageScrolled / 100);
    $el.find('.fill').css('opacity', 1 - $percentageScrolled / 100);
    $el.width($size);
    $el.height($size);
    $el.css({
      top: Math.round($top - $size / 2),
      left: Math.round($left - $size / 2),
    });
  }

  /**
   * Check if element is in the viewport.
   */
  $.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
})(jQuery);
